module.exports = __webpack_public_path__ + "static/img/manage-time.0848878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/manage-time.png
// module id = 4zGx
// module chunks = 0